export function getCurrency(video, channel) {
    var _a, _b;
    var dealInfo = ((_a = video === null || video === void 0 ? void 0 : video.dealInfo) === null || _a === void 0 ? void 0 : _a[0]) || ((_b = channel === null || channel === void 0 ? void 0 : channel.dealInfo) === null || _b === void 0 ? void 0 : _b[0]);
    return dealInfo === null || dealInfo === void 0 ? void 0 : dealInfo.currency;
}
